import { useCallback } from 'react';
import { ColorValues, Flex, RemoteImage } from '@banhala/ui-kit';
import type { DescriptionCardItem } from '../types';
import type { AnyObject } from '../../../../../types';
import { bridge } from '../../../../../utils';
import { HTMLText } from '../../../../HTMLText';

const CARD_WIDTH = 140;
const CARD_IMAGE_HEIGHT = 168;
const DESCRIPTION_ROW_HEIGHT = 44;
const CARD_BORDER_RADIUS = 4;

interface DescriptionCardProps {
  item: DescriptionCardItem;
  logging: AnyObject;
}

export const DescriptionCard = ({ item, logging }: DescriptionCardProps) => {
  const { card_image, deeplink, description } = item;

  const handlePress = useCallback(() => {
    if (deeplink) {
      bridge.logAnalyticsEvent({
        name: 'CLICK_DESCRIPTION_CARD',
        analytics: logging.analytics,
        ably_only_log: logging.ably_only_log,
      });
      bridge.openDeeplink(deeplink);
    }
  }, [deeplink, logging]);

  return (
    <Flex padding={{ top: 4, bottom: 12, horizontal: 4 }}>
      <Flex
        width={CARD_WIDTH}
        borderRadius={CARD_BORDER_RADIUS}
        overflow="hidden"
        backgroundColor="bg_always_white"
        shadowStep="small"
        onPress={handlePress}
      >
        <RemoteImage
          uri={card_image}
          width={CARD_WIDTH}
          height={CARD_IMAGE_HEIGHT}
        />
        <Flex.Row
          height={DESCRIPTION_ROW_HEIGHT}
          alignItems="center"
          padding={{ left: 12 }}
        >
          <HTMLText
            type="body2"
            rawColor={ColorValues.slate50}
            numberOfLines={1}
          >
            {description.text}
          </HTMLText>
          {description.image?.url && (
            <RemoteImage
              uri={description.image.url}
              width={description.image.width}
              height={description.image.height}
            />
          )}
        </Flex.Row>
      </Flex>
    </Flex>
  );
};
